<div id="form-container">
  <form
    [formGroup]="form"
    id="main-form"
    data-testid="main-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
    (ngSubmit)="onSubmit()">
    <h3 class="ui-heading-3-bold">
      @if(activity().acID == undefined){
        Create
      }
      Activity
    </h3>
    <div id="editable">
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Event</rds-control-label>
        <rds-autocomplete
          [options]="eventSuggestions"
          [newItem]="createNewSuggestion"
          selectLastRemainingOnBlur
          selectNewItemOnBlur
          [highlightQuery]="true"
          minSearchChars="0"
          debounce="0"
          formControlName="event"
          placeholder="Select suggestion or start typing"
          data-testid="event"
        />
      </rds-form-field>

      <app-expandable-input label="Title" [control]="form.controls.title" [data-testid]="'title'"></app-expandable-input>

      <div class="rds-form-field">
        <section class="list">
          <p class="rds-form-field__label list-label">Keywords</p>
          <div class="list-content">
          @for (keyword of form.controls.keyWords.controls; track keyword) {
              <rds-form-field labelPosition="side-left">
                <input rdsInput [formControl]="keyword" data-testid="keywords" (keypress)="onKeywordKeypress($event)"/>
                <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                  <button rds-control-suffix rds-icon-button type="button" (click)="removeKeyword($index)"
                          size="s" class="ms-2" data-testid="keyword-remove">
                    <rds-icon namespace="outlined" icon="close"/>
                  </button>
                </div>
              </rds-form-field>
            }
          </div>
        </section>
        <button rds-text-button (click)="addKeyword()" class="ms-auto" type="button" data-testid="keyword-add" [style.visibility]="editorActionsVisible">
          <rds-icon namespace="filled" icon="plus"/>
          Add Keywords
        </button>
      </div>
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Link</rds-control-label>
        <input
          rdsInput
          formControlName="link"
          placeholder="Link"
          data-testid="link"
        />
        @if(form.controls.link.value) {
          <div class="d-flex align-items-center justify-content-end">
            <button rds-icon-button size="m" class="ms-2" type="button">
              <rds-icon namespace="filled" icon="link" (click)="openLink()"></rds-icon>
            </button>
          </div>
        }
      </rds-form-field>
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Due Date</rds-control-label>
        <input rdsInput formControlName="dueDate" [rdsDatepicker]="picker" (focus)="picker.open()" data-testid="dueDate"/>
        <rds-datepicker-toggle rds-control-suffix/>
        <rds-datepicker #picker showToggle="true"></rds-datepicker>
      </rds-form-field>
      <rds-divider></rds-divider>
      <!-- Unified Pillars & Audiences Section -->
      <app-pillars-audiences-section
        entityType="activity"
        [entityId]="activity().abstractID"
        [isViewer]="isViewer"
        [initialPillars]="activity().strategicPillars || []"
        [initialAudiences]="activity().audiences || []"
        (pillarChanged)="onPillarChanged($event)"
        (audienceChanged)="onAudienceSelectionChange($event)">
      </app-pillars-audiences-section>
      <rds-divider></rds-divider>
      <div id="external-profiles">
        @if(!isLoadingProfiles){
          <div class="rds-form-field">
            <section class="list">
              <p class="rds-form-field__label list-label">Ext. Participants</p>
              <div class="list-content">
                @for (participant of form.controls.externalParticipants.controls; track participant) {
                  @if(participant.value.eID === undefined){
                      <app-dynamic-activity-autocompletion type="profile" profileType="participant"
                                                          [excludeOptions]="getExcludedOptions(false)"
                                                          (selection)="profileSelected($any($event), false, $index)"
                      ></app-dynamic-activity-autocompletion>
                  }
                  @else{
                    <rds-form-field labelPosition="side-left" [class.old]="participant.value.isOld">
                      <input rdsInput disabled [value]="participant.value.text" data-testid="participants"/>
                      <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                        <button rds-control-suffix rds-icon-button type="button" (click)="removeProfile($index, false)"
                                size="s" data-testid="participant-remove">
                          <rds-icon namespace="outlined" icon="close"/>
                        </button>
                        <button rds-control-suffix rds-icon-button type="button"
                                (click)="toggleProfileDetailedViewState(!externalParticipantsEditViewStates[$index], $index, false)"
                                size="s" class="ms-4 profile-caret" [class.open]="externalParticipantsEditViewStates[$index]" data-testid="profile-caret">
                          <rds-icon namespace="outlined" icon="chevron_down"/>
                        </button>
                      </div>
                    </rds-form-field>
                    @if(externalParticipantsEditViewStates[$index]){
                      <app-external-profile-detail-view [externalProfile]="getExtendedProfile(participant.value.eID)"></app-external-profile-detail-view>
                    }
                  }
                }
              </div>
            </section>
            <button rds-text-button (click)="addProfile(false)" class="ms-auto" type="button" data-testid="participant-add"  [style.visibility]="editorActionsVisible">
              <rds-icon namespace="filled" icon="plus"/>
              Add Ext. Participant
            </button>
          </div>
          <div class="rds-form-field">
            <section class="list">
              <p class="rds-form-field__label list-label">Ext. Leads</p>
              <div class="list-content">
                @for (lead of form.controls.externalLeads.controls; track lead) {
                  @if(lead.value.eID === undefined){
                      <app-dynamic-activity-autocompletion type="profile" profileType="lead"
                                                          [excludeOptions]="getExcludedOptions(true)"
                                                          (selection)="profileSelected($any($event), true, $index)"
                      ></app-dynamic-activity-autocompletion>
                  }
                  @else{
                    <rds-form-field labelPosition="side-left" [class.old]="lead.value.isOld">
                      <input rdsInput disabled [value]="lead.value.text"  data-testid="leads"/>
                      <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                        <button rds-control-suffix rds-icon-button type="button" (click)="removeProfile($index, true)"
                                size="s" data-testid="lead-remove">
                          <rds-icon namespace="outlined" icon="close"/>
                        </button>
                        <button rds-control-suffix rds-icon-button type="button"
                                (click)="toggleProfileDetailedViewState(!externalLeadsEditViewStates[$index], $index, true)"
                                size="s" class="ms-4 profile-caret" [class.open]="externalLeadsEditViewStates[$index]" data-testid="profile-caret">
                          <rds-icon namespace="outlined" icon="chevron_down"/>
                        </button>
                      </div>
                    </rds-form-field>
                    @if(externalLeadsEditViewStates[$index]){
                      <app-external-profile-detail-view [externalProfile]="getExtendedProfile(lead.value.eID)"></app-external-profile-detail-view>
                    }
                  }
                }
              </div>
            </section>
            <button rds-text-button (click)="addProfile(true)" class="ms-auto" type="button" data-testid="lead-add" [style.visibility]="editorActionsVisible">
              <rds-icon namespace="filled" icon="plus"/>
              Add Ext. Lead
            </button>
          </div>
        } @else {
          <rds-progress-spinner label="Loading External Participants/Leads..." ></rds-progress-spinner>
        }
      </div>
      <rds-divider></rds-divider>
      <div class="rds-form-field">
        <section class="list">
          <p class="rds-form-field__label list-label">Studies</p>
          <div class="list-content">
            @for (study of form.controls.studies.controls; track study) {
              @if(study.value.sID !== undefined){
                <rds-form-field labelPosition="side-left">
                  <input
                    rdsInput
                    disabled
                    [value]="study.value.studyNumber + (study.value.studyName? ', ' + study.value.studyName : '')"
                    placeholder="Study Number, Study Name"
                    data-testid="studies"
                  />
                  <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                    <button rds-control-suffix rds-icon-button type="button" (click)="removeStudy($index)"
                            size="s" class="ms-2" data-testid="lead-remove">
                      <rds-icon namespace="outlined" icon="close"/>
                    </button>
                  </div>
                </rds-form-field>
              }
              @else{
                <app-dynamic-activity-autocompletion type="study" [excludeOptions]="getExcludedStudyOptions()"
                                                  (selection)="studySelected($any($event), $index)"
                ></app-dynamic-activity-autocompletion>
              }
            }
          </div>
        </section>
        <button rds-text-button (click)="addStudy()" class="ms-auto" type="button" data-testid="lead-add" [style.visibility]="editorActionsVisible">
          <rds-icon namespace="filled" icon="plus"/>
          Add one or more Studies
        </button>
      </div>
      <app-expandable-input label="Notes" [control]="form.controls.notes" [data-testid]="'notes'"></app-expandable-input>
      
      
      @if(!isViewer){
        <rds-divider></rds-divider>
        <div id="editable">
          <rds-switch formControlName="isVisible" labelPosition="before" [checked]="form.controls.isVisible">Visible for viewers?</rds-switch>
        </div>
      }
    </div>
    <div id="controls">
      @if(activity().acID){
        <button rds-secondary-warning-button type="button" [disabled]="isLoadingChanges()" (click)="onDelete()" [style.visibility]="editorActionsVisible">Delete</button>
      }
        <button rds-primary-button class="ms-auto" type="submit" [disabled]="isLoadingChanges()" size="m" data-testid="submit" [style.visibility]="editorActionsVisible">
        @if(!isLoadingChanges()){
          Save
        }
        @else{
          <rds-progress-spinner label="Updating..." size="m" white></rds-progress-spinner>
        }
      </button>
    </div>
  </form>
</div>
